export function voyageToughtLeaderCounterAnimation (qSelector, start = 0, end = 1000, duration = 1000, thousandSeparator = "") {
    const target = document.querySelector(qSelector);
    if (!target)
        return;

    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const result = formatNumber(Math.floor(progress * (end - start) + start), thousandSeparator);
        target.innerText = result;
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);

    const formatNumber = (num, thousandSeparator = "") => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    }
}